import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '@/auth/use-auth';
import UiLoader from '@/ui/UiLoader/UiLoader';
import UiButton from '@/ui/UiButton/UiButton';
import UiIcon from '@/ui/UiIcon/UiIcon';
import UiInput from '@/ui/UiInput/Uiinput';
import { getClientConfig } from '@/hooks/helpers';

export default function Login() {
  const navigate = useNavigate();
  const {
    loginWithRedirect,
    runForcedRedirect,
    loginWithQuuidRedirect,
    loginWithPopup,
    loginWithNewTab,
    getWidget,
    changeConfigData,
    isLoading,
    access_token,
  } = useAuth();
  const [ configData, setConfigData ] = React.useState<{ scopes: string, redirectUri: string}>({ scopes: '', redirectUri: ''});

  const onChangeConfig = (config: { scopes: string, redirectUri: string }): void => {
    setConfigData(config);
    changeConfigData(config);
  }

  React.useLayoutEffect(() => {
    if (access_token) {
      navigate('/');
    }
  }, [navigate, access_token]);

  if (isLoading) {
    return <UiLoader />;
  }

  return (
    <div className='page'>
      <div className='page-logo-wrapper'>
        <div className='header-logo'>
          <UiIcon name="logo" />
        </div>
        <h1 className="page-title">
          Войти
        </h1>
      </div>
      <div className="grid page-content-wrapper">
        <div className="button index-element-1" id="button1" data-testid="enter-with-gpid" />
        <UiButton
          type='secondary'
          className='index-element-1'
          dataTestId="enter-lite"
          onClick={() => navigate('/login-lite')}
        >
          Войти lite
        </UiButton>
        <UiButton
          type='secondary'
          className='index-element-2'
          dataTestId="show-widget"
          onClick={() => getWidget()}
        >
          Показать виджет
        </UiButton>
        <UiButton
          type='secondary'
          className='index-element-3'
          dataTestId="enter-with-redirect"
          onClick={() => loginWithRedirect()}
        >
          Войти с редиректом
        </UiButton>
        <UiButton
          type='secondary'
          className='index-element-4'
          dataTestId="enter-with-forced-redirect"
          onClick={() => {
            const clientConfig = getClientConfig();
            runForcedRedirect(clientConfig.loginTag, clientConfig.type);
          }}
        >
          Принудительная аутентификация
        </UiButton>
        <UiButton
          type='secondary'
          className='index-element-5'
          dataTestId="enter-with-popup"
          onClick={() => loginWithPopup()}
        >
          Войти с попапом
        </UiButton>
        <UiButton
          type='secondary'
          className='index-element-6'
          dataTestId="enter-with-new-tab"
          onClick={() => loginWithNewTab()}
        >
          Войти через новую вкладку
        </UiButton>
        <UiButton
          type='secondary'
          className='index-element-7'
          dataTestId="enter-with-qr"
          onClick={() => loginWithQuuidRedirect()}
        >
          Войти с QR-кодом
        </UiButton>
        <UiButton
          type='secondary'
          className='index-element-8'
          dataTestId="open-gid-gpb-flow"
          onClick={() => navigate('/?flow=gid_gpb')}
        >
          Открыть с flow=gid_gpb
        </UiButton>
        <UiButton
          type='flat'
          size='small'
          className='index-element-9'
          dataTestId="back-btn"
          onClick={() => navigate('/')}
        >
          Назад
        </UiButton>
        <div>Следующие параметры конфига можно переопределить:</div>
        <UiInput label="scopes" dataTestId="scopes" value={configData.scopes} onChange={(e) => onChangeConfig({ scopes: e.target.value, redirectUri: configData.redirectUri })} />
        <UiInput label="redirectUri" dataTestId="redirectUri" value={configData.redirectUri} onChange={(e) => onChangeConfig({ scopes: configData.scopes, redirectUri: e.target.value })} />
      </div>
    </div>
  );
}
